import { render, staticRenderFns } from "./productionReport-add-or-update.vue?vue&type=template&id=63d96e69&scoped=true"
import script from "./productionReport-add-or-update.vue?vue&type=script&lang=js"
export * from "./productionReport-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./productionReport-add-or-update.vue?vue&type=style&index=0&id=63d96e69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d96e69",
  null
  
)

export default component.exports